import { EnvironmentProviders, inject, provideEnvironmentInitializer, Provider } from '@angular/core';

import { NotificationService } from './notification.service';

export function provideNotifications(): (Provider | EnvironmentProviders)[] {
  return [provideEnvironmentInitializer(() => inject(NotificationService))];
}
